import { render, staticRenderFns } from "./OrigemAcesso.vue?vue&type=template&id=28526554&scoped=true&"
import script from "./OrigemAcesso.vue?vue&type=script&lang=js&"
export * from "./OrigemAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28526554",
  null
  
)

export default component.exports